import * as React from 'react';
import { SVGProps } from 'react';

const IconSlideSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1H4v10h1V1Zm3 0H7v10h1V1Z"
    />
  </svg>
);
export default IconSlideSizeXs;
